import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AuthStore, DocumentsStore } from '@store';
import { DocumentsUpdateFormGroup } from './documents-update-modal.helper';

@Component({
  selector: 'app-documents-update',
  templateUrl: './documents-update-modal.component.html',
  styleUrls: ['./documents-update-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentsUpdateComponent implements OnInit, OnDestroy {
  documentForm: FormGroup<DocumentsUpdateFormGroup>;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<DocumentsUpdateComponent>,
    public documentsStore: DocumentsStore,
    private authStore: AuthStore
  ) {}

  ngOnInit(): void {
    this.documentsStore.updatedDocuments$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((documents) => {
        const formControls = documents.map(() => new FormControl(false, [Validators.requiredTrue]));
        this.documentForm = new FormGroup<DocumentsUpdateFormGroup>({
          documents: new FormArray(formControls),
        });
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  getControls(): FormControl<boolean>[] {
    return this.documentForm.controls.documents.controls;
  }

  onConfirm(): void {
    this.documentsStore.agreeOnDocuments();
    this.dialogRef.close();
  }

  onCancel(): void {
    this.authStore.logout();
    this.dialogRef.close();
  }
}
